import _ from "lodash";
/**--external-- */
import React from "react";

/**--internal-- */
import { DragAndDropList as DSDragAndDropList } from "@toddle-edu/ds-web";
import Listview from "UIComponents/Listview";
import { DragAndDropList } from "UIComponents/UIInputList";
import { getInputNumberListValues } from "Fields/FieldUtils";
import I18nHOC from "UIComponents/I18nHOC";

/**--relative-- */
import Field from "../Field";
import classes from "./FieldInputList.scss";
import GenericListView from "UIComponents/GenericListView";

class FieldInputList extends Field {
  renderPreviewContent = () => {
    const { data, showListItemNumber } = this.props;

    return (
      <div className={classes.container}>
        <DSDragAndDropList
          mode="view"
          value={data}
          showListItemNumber={showListItemNumber ?? true}
          showAddAnotherItemButton={false}
        />
      </div>
    );
  };

  renderView = () => {
    const {
      value,
      subText,
      fieldKey,
      emptyText,
      customTextStyle = {},
      isSinglePageAndNewUnitView,
      showListItemNumber,
    } = this.props;
    const filteredValue = showListItemNumber
      ? value
      : _.filter(value, item => item.isSelected);
    const fieldValues = getInputNumberListValues({ value });

    return isSinglePageAndNewUnitView ? (
      <GenericListView
        nodes={value}
        rootNodeIds={_.map(filteredValue, "id")}
        type={"ordered"}
        shouldEmphasisRootNodes={false}
      />
    ) : (
      <Listview
        value={fieldValues}
        emptyText={emptyText}
        mode={"view"}
        subText={subText}
        name={fieldKey}
        listType={"number"}
        customTextStyle={customTextStyle}
      />
    );
  };

  shouldShowViewEmpty = () => {
    const { value, showListItemNumber } = this.props;
    const filteredValue = showListItemNumber
      ? value
      : _.filter(value, item => item.isSelected);

    // return true if value is empty or if value has only one item and that item is empty
    return (
      _.isEmpty(filteredValue) ||
      (_.size(filteredValue) === 1 && _.isEmpty(value[0]?.value))
    );
  };

  getSinglePageNewUnitPlanViewDnDProps = () => {
    const {
      isSinglePageAndNewUnitView,
      isDisabled,
      showListItemNumber,
      shouldInitOptions,
      options,
      isDependentField,
      emptyText,
      emptyEditText,
      enhancedEmptyTextFormat,
    } = this.props;
    return isSinglePageAndNewUnitView
      ? {
          dsVersion: "2.0",
          showSeparator: false,
          showAddAnotherItemButton: !isDisabled,
          showListItemNumber,
          shouldInitOptions,
          options,
          isDependentField,
          emptyText,
          emptyEditText,
          enhancedEmptyTextFormat,
        }
      : {};
  };

  renderEdit = () => {
    const {
      value,
      updateInputField,
      isDisabled = false,
      onFocusInputField,
      onBlurInputField,
      name,
      customRef,
      isLocked,
      readOnly,
    } = this.props;

    return (
      <div className={classes.mainContainer}>
        <DragAndDropList
          value={value}
          listType={"numberList"}
          isDisabled={isDisabled}
          updateInputField={updateInputField}
          onFocusInputField={onFocusInputField}
          onBlurInputField={onBlurInputField}
          name={name}
          customRef={customRef}
          isLocked={isLocked}
          readOnly={readOnly}
          {...this.getSinglePageNewUnitPlanViewDnDProps()}
        />
      </div>
    );
  };
}

export default I18nHOC({ resource: "common" })(FieldInputList);

FieldInputList.defaultProps = {
  ...Field.defaultProps,
  data: [],
  showListItemNumber: true,
};

FieldInputList.displayName = "FieldInputList";
